import StagesOverview from '../components/stage/StagesOverview'
import ProcessInfo from '../components/process/ProcessInfo'
import PageContainer from '../components/common/PageContainer'
import { useGetProcess, useGetUserProcessAccess } from '../api/process'
import { useParams } from 'react-router-dom'
import { Step } from 'intro.js-react'

export default function Dashboard() {
  const { pid } = useParams<{ pid: string }>()
  const { data: process } = useGetProcess(pid)
  const { data: accesses } = useGetUserProcessAccess(pid)

  return (
    <PageContainer
      introSteps={steps}
      header={
        <ProcessInfo
          year={process?.year}
          number={process?.number}
          description={process?.description}
          organization={process?.organization}
        />
      }
    >
      <StagesOverview stages={process?.stages} accesses={accesses} />
    </PageContainer>
  )
}

const steps: Step[] = [
  {
    element: '#process-title',
    intro: 'شماره، شرکت و عنوان فرایند',
  },
  {
    element: '#stages-list',
    intro: 'در اینجا لیست مراحل و وضعیت‌ هر یک را مشاهده می‌کنید.',
  },
  {
    element: '.stage-card',
    intro:
      'وضعیت مراحل از حاشیه کارت‌ها مشخص است. آبی: درجریان، خاکستری: شروع‌نشده، مشکی: پایان‌یافته',
  },
  {
    element: '.stage-deadline',
    intro: 'زمان طی شده و موعد اتمام مرحله',
  },
  {
    element: '#home-button',
    intro: 'رفتن به صفحه‌ی فرایند‌ها',
  },
]
